
/*const enterpriseApiUrl = 'https://cent.vodokanal.mk.ua/'*/

const enterpriseApiUrl = 'https://cent.vodokanal.mk.ua/'

export default enterpriseApiUrl;
